import React from 'react';
import {
  Box,
  Container,
  Flex,
  Text,
  Image,
  Link,
  Input,
  Button,
  SimpleGrid,
  VStack,
  HStack,
  Icon,
} from '@chakra-ui/react';
import { Parallax } from 'react-parallax';
import { Link as RouterLink } from 'react-router-dom';
import { FaEnvelope, FaMapMarkerAlt, FaPhone, FaFacebookF, FaYoutube, FaInstagram, FaTwitter, FaArrowRight  } from 'react-icons/fa';
import logo from '../../assets/Logo.webp';
import backgroundImage from '../../assets/Footer2.jpg';

function Footer() {
  return (
    <Parallax
      bgImage={backgroundImage}
      strength={300}
      bgImageStyle={{ objectFit: 'cover' }}
    >
      <Box
        as="footer"
        py={16}
        bg="rgba(0, 0, 0, 0.59)" // gray.900 with 75% opacity
        color="white"
        position="relative"
        minH="400px"
      >
        <Container maxW="7xl" position="relative" zIndex={2}>
          <SimpleGrid
            columns={{ base: 1, md: 2, lg: 4 }}
            spacing={8}
            mb={5}
          >
            {/* About Us */}
            <VStack align="start" spacing={4}>
              <Image
                src={logo}
                alt="Company Logo"
                maxW="150px"
                loading="lazy"
              />
              <Text color="gray.300" maxW="md">
                We are a leading digital solutions provider, delivering innovative websites, mobile apps, and marketing strategies to help businesses thrive in the digital age.
              </Text>
              <Box w="full">
                <VStack align="start" spacing={2}>
                  <Text fontWeight="bold">Subscribe to Our Newsletter</Text>
                  <HStack>
                    <Input
                      placeholder="Email Address"
                      type="email"
                      bg="white"
                      color="gray.800"
                      _placeholder={{ color: 'gray.500' }}
                      size="md"
                    />
                    <Button bg="customDarkBlue.600" size="md">
                      Subscribe
                    </Button>
                  </HStack>
                  <Text fontSize="sm" color="gray.400">
                    * We will not share your personal info
                  </Text>
                </VStack>
              </Box>
            </VStack>

            {/* Useful Links */}
            <VStack align="start" spacing={4}>
              <Text fontSize="xl" fontWeight="bold">
                COMPANY
              </Text>
              <VStack align="start" spacing={2}>
                <Link href="https://www.google.com" isExternal display="flex" alignItems="center">
                  <Icon as={FaArrowRight} mr={2} /> About Us
                </Link>
                <Link href="https://dribbble.com" isExternal display="flex" alignItems="center">
                  <Icon as={FaArrowRight} mr={2} /> Services
                </Link>
                <Link href="https://linkedin.com" isExternal display="flex" alignItems="center">
                  <Icon as={FaArrowRight} mr={2} /> Contact Us
                </Link>
                <Link href="https://wikipedia.org" isExternal display="flex" alignItems="center">
                  <Icon as={FaArrowRight} mr={2} /> Blog
                </Link>
              </VStack>
            </VStack>

            {/* Resources */}
            <VStack align="start" spacing={4}>
              <Text fontSize="xl" fontWeight="bold">
                HELP
              </Text>
              <VStack align="start" spacing={2}>
                <Link as={RouterLink} to="/support" display="flex" alignItems="center">
                  <Icon as={FaArrowRight} mr={2} /> Customer Support
                </Link>
                <Link as={RouterLink} to="/dashboard" display="flex" alignItems="center">
                  <Icon as={FaArrowRight} mr={2} /> Terms & Conditions
                </Link>
                <Link as={RouterLink} to="/drivers" display="flex" alignItems="center">
                  <Icon as={FaArrowRight} mr={2} /> Privacy Policy
                </Link>
                <Link as={RouterLink} to="/projects" display="flex" alignItems="center">
                  <Icon as={FaArrowRight} mr={2} /> Projects
                </Link>
              </VStack>
            </VStack>

            {/* Contact Information */}
            <VStack align="start" spacing={4}>
              <Text fontSize="xl" fontWeight="bold">
                Contact Information
              </Text>
              <VStack align="start" spacing={3}>
                <HStack>
                  <Icon as={FaEnvelope} color="customDarkBlue.600" />
                  <Link href="mailto:support@example.com" color="gray.300">
                  dremotechsolutions@gmail.com
                  </Link>
                </HStack>
                <HStack>
                  <Icon as={FaMapMarkerAlt} color="customDarkBlue.600" />
                  <Text color="gray.300">Dremotech Solutions, Peyad, Thiruvananthapuram, Kerala </Text>
                </HStack>
                <HStack>
                  <Icon as={FaPhone} color="customDarkBlue.600" />
                  <Link href="tel:+9197472 84683" color="gray.300">
                  9747284683
                  </Link>
                </HStack>
                <HStack spacing={4}>
                  <Link href="https://facebook.com" isExternal>
                    <Icon as={FaFacebookF} boxSize={6} color="gray.300" _hover={{ color: 'teal.400' }} />
                  </Link>
                  <Link href="https://youtube.com" isExternal>
                    <Icon as={FaYoutube} boxSize={6} color="gray.300" _hover={{ color: 'teal.400' }} />
                  </Link>
                  <Link href="https://instagram.com" isExternal>
                    <Icon as={FaInstagram} boxSize={6} color="gray.300" _hover={{ color: 'teal.400' }} />
                  </Link>
                  <Link href="https://twitter.com" isExternal>
                    <Icon as={FaTwitter} boxSize={6} color="gray.300" _hover={{ color: 'teal.400' }} />
                  </Link>
                </HStack>
              </VStack>
            </VStack>
          </SimpleGrid>

          <Flex
            borderTopWidth="1px"
            borderColor="gray.700"
            pt={8}
            direction={{ base: 'column', md: 'row' }}
            align="center"
            justify="space-between"
          >
            <Text color="gray.400" fontSize="sm">
              &copy; {new Date().getFullYear()} Dremotech Solutions. All rights reserved.
            </Text>
            <HStack spacing={4}>
              <Link as={RouterLink} to="/terms" color="gray.400" _hover={{ color: 'teal.400' }}>
                Terms of Use
              </Link>
              <Text color="gray.400">|</Text>
              <Link as={RouterLink} to="/privacy" color="gray.400" _hover={{ color: 'teal.400' }}>
                Privacy Policy
              </Link>
            </HStack>
          </Flex>
        </Container>
      </Box>
    </Parallax>
  );
}

export default Footer;